import React, { useEffect, useState } from "react";

function LoadingPage() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let width = 0;
    const interval = setInterval(() => {
      // mimic Gmail-like non-linear progress
      width += Math.random() * 15;
      if (width >= 95) width = 95; // never reach 100% until load complete
      setProgress(width);
    }, 200);

    return () => clearInterval(interval);
  }, []);
  return (
    <div className="banner-section" style={{ backgroundColor: "white" }}>
      <div className="container">
        <h1 data-aos="fade-down" data-aos-delay="300" data-aos-duration="1000">
          <div className="navbar-brand">
            <img
              src={
                "https://nexcorp.in/projects/bluediomondvoyage/html/images/logo.webp"
              }
              className="img-fluid logo-img"
              alt="logo"
            />
          </div>
        </h1>
        {/* <div
          className="ban-onfo"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="2000"
        >
          {data.subtitle}
        </div>
        <div
          className="all-btn-area"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="3000"
        >
          <a href={data.button_link} className="all-btn">
            {data.button_text}
          </a>
        </div> */}
        <div
          className="transition-all duration-300 ease-out"
          style={{
            width: `${progress}%`,
            backgroundColor: "#1288DB",
            height: "3px",
          }}
        ></div>
      </div>
    </div>
  );
}

export default LoadingPage;
